module.exports = __webpack_public_path__ + "fonts/Nunito-400-latin-ext4.e8049e6.woff2";